export default "__VITE_ASSET__DEdUBjRs__"